import _extends from "@babel/runtime/helpers/extends";
import classNames from 'classnames';
import React from 'react';
import { TextFieldTheme, TextField as TPATextField } from 'wix-ui-tpa/cssVars';
import { ForcedState, useForcedState } from '../../../contexts/forced-state-context';
import { useTranslation } from '../../../contexts/translation-context';
import { classes } from './year-field-wut.st.css';
export function YearFieldWUT(props) {
  const {
    id,
    className,
    onChange,
    ...rest
  } = props;
  const {
    t
  } = useTranslation();
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  return /*#__PURE__*/React.createElement(TPATextField, _extends({}, rest, {
    type: "text",
    inputMode: "numeric",
    newErrorMessage: true,
    maxLength: 4,
    theme: TextFieldTheme.Box,
    onChange: handleChange,
    "aria-label": t('field.date.placeholder.year'),
    className: classNames(className, classes.root, classes.theme, {
      [classes.hover]: forcedHover
    })
  }));
  function handleChange(event) {
    props.onChange == null || props.onChange(event.target.value);
  }
}
//# sourceMappingURL=year-field-wut.js.map